import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";

import schoolApi from "../../api/schoolApi.jsx";
import { ShimmerTable } from "react-shimmer-effects";
import InfoPill from "../InfoPill.jsx";
import Confirm from "../Confirm.jsx";
import { Link } from "react-router-dom";
import Main from "../layout/Main.jsx";
import AddSubject from "./add_subject.jsx";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdFilterAlt } from "react-icons/md";
import FilterComponent from "./filter_component.jsx";
import { MdFilterList as FilterListIcon } from "react-icons/md";
import {
  DatatableWrapper,
  Filter,
  PaginationOptions,
  TableBody,
  TableHeader,
  Pagination,
} from "react-bs-datatable";
import { IconButton } from "@mui/material";
import { usePermissions } from "../contexts/PermissionContext";
import { Helmet } from "react-helmet";

const SubjectList = (props) => {
  const [addSearchRecShow, setAddSearchRecShow] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [rowRecords, setRowRecords] = useState([]);
  const [optionnames, setOptionNames] = useState([]);
  const [colSize, setColSize] = useState({ tableSize: 12, filterSize: 0 });
  const [isFilter, setIsFilter] = useState(false);
  const [body, setBody] = useState([]);
  const [addModalShow, setAddModalShow] = useState(false);
  const [rowData, setRowData] = useState();
  const { rolePermissions, userInfo } = usePermissions();
  const canCreate = rolePermissions?.Subject_List?.can_create;
  const canEdit = rolePermissions?.Subject_List?.can_edit;

  const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  };


  const delayedGetData = debounce(async (text) => {
    await getData(text);
  }, 900);

  const getData = async (text) => {
    try {
      const result = await schoolApi.getSubjectRecordName(text);
      if (result.success) {
        setBody(result.result);
      } else {
        setBody([]); // Set a default value
      }

    } catch (error) {
      console.error("Error fetching subject records:", error);
    }
  };

 

  const fetchSubjectRecords = async () => {
   
    try {
      let result = await schoolApi.getSubjectRecord();
      if (result.success) {
        result = result.result;

        const extractedFields = {
          name: result?.name,
          shortname: result?.shortname,
          status: result?.status,
          type: result?.type,
        };


        result?.map((res) => {
          setOptionNames((prevVal) => [
            ...prevVal,
            { value: res.id, label: res.name },
          ]);
        });
       
        if (result) {
          setBody(result);
        }
      } else {
        toast.error(result.message);
        setBody([]);
      }
    } catch (error) {
     
      toast.error(error.response.data.message);
    }
  };

 

  useEffect(() => {
    fetchSubjectRecords();
  }, []);

  const toggleStatus = (row) => {

    if (
      canEdit ||
      userInfo?.userrole === "SYS_ADMIN" ||
      userInfo?.userrole === "ADMIN"
    ) {
      setUpdateStatus(true);
      setRowRecords(row);
    }
  };



  const changeStatus = async () => {
    try {
      if (rowRecords.status === "Active") {
        rowRecords.status = "Inactive";
      } else {
        rowRecords.status = "Active";
      }
      const result = await schoolApi.updateSubjectRecord(rowRecords);
     
      if (result.success) {
        setUpdateStatus(false);
      }
    } catch (error) {
      
      if (rowRecords.status === "Active") {
        rowRecords.status = "Inactive";
      } else {
        rowRecords.status = "Active";
      }

        toast.error(error.response.data.message);
    }
  };



  const header = [
    {
      title: "Subject Name",
      prop: "name",
      show: true,
      isFilterable: true,
    },
    { title: "Short Name", prop: "shortname", show: true, isFilterable: true }, // Add by Aamir khan

    { title: "Type", prop: "type", show: true, isFilterable: true },
    {
      title: "Actions",
      prop: "id",
      show:
        userInfo?.userrole === "SYS_ADMIN" || userInfo?.userrole === "ADMIN"
          ? true
          : canEdit,
      cell: (row) => (
        <>
          <Button
            className="btn-sm mx-2 edit-button"
            variant=""
            onClick={() => handleUpdate(row)}
          >
            <i className="fa-regular fa-pen-to-square"></i>
          </Button>
        </>
      ),
    },

    {
      title: "Status",
      prop: "status",
      show: true,
      isFilterable: true,
      cell: (row) => (
        <Button
          className="btn-sm mx-2"
          style={{ width: "80px" }}
          variant={row.status === "Active" ? "success" : "danger"}
          onClick={() => toggleStatus(row)}
        >
          {row.status}
        </Button>
      ),
    },


  ];

  const visibleHeader = header?.filter((col) => col.show);

  const addSubjectRecord = () => {
    setAddModalShow(true);
    setRowData([]);
  };

  {
    
  }
  const addSub = () => {
    setAddSearchRecShow(!addSearchRecShow);
    setIsFilter(!isFilter);

    if (isFilter) fetchSubjectRecords();

    if (!addSearchRecShow) {
      setColSize({ tableSize: 9, filterSize: 3 });
    } else {
     
      setColSize({ tableSize: 12, filterSize: 0 });
    }
    setRowData([]);
  };

  const handleUpdate = async (row) => {
   
    setAddModalShow(true);
    setRowData(row);
  };

  const labels = { beforeSelect: " " };

  const recordSavedSuccessfully = () => {
    setAddModalShow(false);
    fetchSubjectRecords();
  };

  return (
    <>
      <Helmet>
        <title>{props?.tabName}</title>
      </Helmet>
      {}
      {updateStatus && (
        <Confirm
          show={updateStatus}
          onHide={() => setUpdateStatus(false)}
          changeStatus={changeStatus}
          title={`Confirm ${
            rowRecords?.status == "Active" ? "in Active" : "Active"
          } ?`}
          message="You are going to update the status. Are you sure?"
          table="exam_title_status_update"
        />
      )}

      {}

      <Row className="g-0">
        {addModalShow && (
          <AddSubject
            show={addModalShow}
            parent={rowData}
            onHide={() => setAddModalShow(false)}
            recordSavedSuccessfully={recordSavedSuccessfully}
          />
        )}

        {}
        <Col lg={12} className="p-lg-5">
          {body ? (

            <DatatableWrapper
              body={body}
              headers={visibleHeader}
              rowIndexColumn
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 10,
                  options: [5, 10, 15, 20],
                },
              }}
            >
              {}

              <Col lg={5} className="mx-1" style={{ marginTop: "-35px" }}>
                <Link className="nav-link" to="/">
                  Home <i className="fa-solid fa-chevron-right"></i> Subjects
                </Link>
              </Col>
              <Row className="mb-4">
                <Col
                  xs={12}
                  sm={6}
                  lg={3}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Filter />
                </Col>

                <Col
                  xs={12}
                  sm={6}
                  lg={4}
                  className="d-flex flex-col justify-content-start align-items-start"
                >
                  <PaginationOptions labels={labels} />
                  <div style={{ marginTop: "5px" }}>
                    <InfoPill left=" Total Subjects " right={body?.length} />
                  </div>
                </Col>
                <Col
                  xs={12}
                  sm={6}
                  lg={5}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  {(userInfo?.userrole === "SYS_ADMIN" ||
                    userInfo?.userrole === "ADMIN" ||
                    canCreate) && (
                    <Button
                      className="btn add-new-button"
                      variant=""
                      onClick={addSubjectRecord}
                    >
                      Add Subject
                    </Button>
                  )}
                  {}
                  <Button
                    className="btn"
                    variant="outline-secondary"
                    onClick={addSub}
                    style={{ marginTop: "18px", marginLeft: "10px" }}
                  >
                    <span className="d-inline-flex align-items-center">
                      <MdFilterAlt
                        style={{
                          marginRight: "0px",
                          paddingTop: "2px",
                          fontSize: "15px",
                        }}
                      />
                    </span>
                  </Button>
                  {}
                </Col>
              </Row>

              {}
              <Row>
                <Col lg={`${colSize.tableSize}`}>
                  <Table
                    striped
                    className="data-table custom-table-subject-list"
                  >
                    <TableHeader />
                    <TableBody />
                  </Table>
                  <Pagination />
                </Col>
                {console.log("Subject_List")}
                <Col lg={colSize.filterSize}>
                  {addSearchRecShow && (
                    <FilterComponent
                      show={addSearchRecShow}
                      parent={rowData}
                      onHide={() => setAddSearchRecShow(false)}
                      setBody={setBody}

                    />
                  )}
                </Col>
              </Row>
              {}
            </DatatableWrapper>
          ) : (

            <ShimmerTable row={10} col={8} />
          )}
          {}
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default SubjectList;
